"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _reactRouterRedux = require("react-router-redux");

var _reactRouter = require("react-router");

var _NotificationList = _interopRequireDefault(require("ReduxMessenger/components/NotificationList"));

var _underscore = require("underscore");

var _UIConfirmModal = _interopRequireDefault(require("UIComponents/dialog/UIConfirmModal"));

var _UIEditorPage = _interopRequireDefault(require("UIComponents/page/UIEditorPage"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _DynoPanels = _interopRequireDefault(require("./DynoPanels"));

var _DynoTypePanel = _interopRequireDefault(require("./DynoTypePanel"));

var _DynoCalloutPanel = _interopRequireDefault(require("./DynoCalloutPanel"));

var _DynoFormPanel = _interopRequireDefault(require("./DynoFormPanel"));

var _DynoThankYouPanel = _interopRequireDefault(require("./DynoThankYouPanel"));

var _DynoOptionsPanel = _interopRequireDefault(require("./DynoOptionsPanel"));

var _DynoPublishPanel = _interopRequireDefault(require("./DynoPublishPanel"));

var _TitleNavigationBar = _interopRequireDefault(require("lead-flows-ui/components/editor/navigation/TitleNavigationBar"));

var _TabsNavigationBar = _interopRequireDefault(require("lead-flows-ui/components/editor/navigation/TabsNavigationBar"));

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var _RouteGenerators = require("lead-flows-ui/lib/RouteGenerators");

var _DynoValidation = require("lead-flows-ui/constants/DynoValidation");

var _Scopes = require("lead-flows-ui/constants/Scopes");

var _FormFieldTypes = _interopRequireDefault(require("lead-flows-ui/constants/FormFieldTypes"));

var _DynoUtils = require("lead-flows-ui/utils/DynoUtils");

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

var CanSpamSettingsActions = _interopRequireWildcard(require("lead-flows-ui/actions/CanSpamSettings"));

var DynoEditorActions = _interopRequireWildcard(require("lead-flows-ui/actions/DynoEditor"));

var DynoImageActions = _interopRequireWildcard(require("lead-flows-ui/actions/DynoImages"));

var HubSettingsActions = _interopRequireWildcard(require("lead-flows-ui/actions/HubSettings"));

var _Subscriptions = require("lead-flows-ui/actions/Subscriptions");

var _RequestState = require("lead-flows-ui/utils/RequestState");

var _CanSpamSettingsUtils = require("lead-flows-ui/utils/CanSpamSettingsUtils");

var EmailSubscriptionsActions = _interopRequireWildcard(require("lead-flows-ui/actions/EmailSubscription"));

var _EmailSubscription2 = require("lead-flows-ui/selectors/EmailSubscription");

var _Scopes2 = require("lead-flows-ui/selectors/Scopes");

var _CanSpamSettings2 = require("lead-flows-ui/selectors/CanSpamSettings");

var HubSettingsSelectors = _interopRequireWildcard(require("lead-flows-ui/selectors/HubSettings"));

var _AudienceTargetingContainer = _interopRequireDefault(require("./TargetingOptions/AudienceTargetingContainer"));

var _AsyncDynoFollowUpEmailPanel = _interopRequireDefault(require("lead-flows-ui/loadable/AsyncDynoFollowUpEmailPanel"));

var _Dynos = require("lead-flows-ui/selectors/Dynos");

var _hubspotPluginCommon = require("hubspot-plugin-common");

var EDITOR_STEPS = Object.values(_DynoEditor.STEPS || {});
var CURRENT_DYNO_VERSION = 3;
var DEFAULT_FIELD_TYPES = Object.values(_FormFieldTypes.default || {});

var DynoEditor =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DynoEditor, _PureComponent);
  (0, _createClass2.default)(DynoEditor, null, [{
    key: "propTypes",
    get: function get() {
      return {
        allGates: _react.default.PropTypes.array.isRequired,
        brandingEnabled: _react.default.PropTypes.bool.isRequired,
        dispatch: _react.default.PropTypes.func.isRequired,
        dyno: _react.default.PropTypes.object.isRequired,
        dynoId: _react.default.PropTypes.string,
        gates: _react.default.PropTypes.object.isRequired,
        handleAdvanceStep: _react.default.PropTypes.func.isRequired,
        handleChangeStep: _react.default.PropTypes.func.isRequired,
        hasChanges: _react.default.PropTypes.bool.isRequired,
        hasCustomFieldsScope: _react.default.PropTypes.bool.isRequired,
        HubSettingsActions: _react.default.PropTypes.object.isRequired,
        hubSettingsUpdateRequestState: _react.default.PropTypes.instanceOf(_RequestState.RequestState).isRequired,
        isCrmUser: _react.default.PropTypes.bool.isRequired,
        isEditing: _react.default.PropTypes.bool.isRequired,
        isSettingsFetching: _react.default.PropTypes.bool.isRequired,
        lastSaveAt: _react.default.PropTypes.number,
        route: _react.default.PropTypes.object,
        router: _react.default.PropTypes.object,
        saving: _react.default.PropTypes.bool.isRequired,
        savingHasError: _react.default.PropTypes.bool.isRequired,
        savingRecentError: _react.default.PropTypes.object,
        settings: _react.default.PropTypes.object.isRequired,
        step: _react.default.PropTypes.oneOf(EDITOR_STEPS).isRequired,
        subscriptions: _react.default.PropTypes.object.isRequired,
        validation: _react.default.PropTypes.object.isRequired,
        EmailSubscriptionsActions: _react.default.PropTypes.object.isRequired,
        emailSubscriptions: _react.default.PropTypes.array.isRequired,
        emailDefaultSubscription: _react.default.PropTypes.number,
        emailSubscriptionsRequestState: _react.default.PropTypes.instanceOf(_RequestState.RequestState).isRequired,
        portalDomain: _react.default.PropTypes.string.isRequired,
        readOnly: _react.default.PropTypes.bool.isRequired,
        users: _react.default.PropTypes.array.isRequired,
        redirectUrl: _react.default.PropTypes.string,
        hasEmailSubscriptionScope: _react.default.PropTypes.bool.isRequired,
        canSpamSettingsActions: _react.default.PropTypes.object.isRequired,
        originalCanSpamSettings: _react.default.PropTypes.object.isRequired,
        canSpamSettingsHasLoaded: _react.default.PropTypes.bool.isRequired,
        isUngatedForMergedDashboard: _react.default.PropTypes.bool.isRequired,
        hasForm: _react.default.PropTypes.bool
      };
    }
  }]);

  function DynoEditor(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DynoEditor);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DynoEditor).call(this, props));
    _this.state = {
      showLeaveDialog: false,
      showMissingKickBackEmailWarning: false,
      emailSubscriptionId: null,
      emailSubscriptionIdError: false
    };
    _this.updateDyno = _this.updateDyno.bind((0, _assertThisInitialized2.default)(_this));
    _this.addValidationError = _this.addValidationError.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeValidationError = _this.removeValidationError.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleImageChange = _this.handleImageChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetchEspStatus = _this.fetchEspStatus.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleNameChange = _this.handleNameChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleNameBlur = _this.handleNameBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRouterLeave = _this.handleRouterLeave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLeaveConfirm = _this.handleLeaveConfirm.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLeaveCancel = _this.handleLeaveCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLeave = _this.handleLeave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSave = _this.handleSave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDeleteDraft = _this.handleDeleteDraft.bind((0, _assertThisInitialized2.default)(_this));
    _this.publish = _this.publish.bind((0, _assertThisInitialized2.default)(_this));
    _this.unpublish = _this.unpublish.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCompleteModal = _this.handleCompleteModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDismissKickBackEmailWarning = _this.handleDismissKickBackEmailWarning.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKickBackEmailErrors = _this.handleKickBackEmailErrors.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleUpdateEmailSubscriptionId = _this.handleUpdateEmailSubscriptionId.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCanSpamMissing = _this.handleCanSpamMissing.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleFormFieldValidation = _this.handleFormFieldValidation.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DynoEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('beforeunload', this.handleLeave);
      this.props.router.setRouteLeaveHook(this.props.route, this.handleRouterLeave);
      this.props.dispatch(DynoEditorActions.removeAllValidationErrors());
      this.props.dispatch(DynoEditorActions.getDraftChangesIfNeeded());
      this.handleFormFieldValidation(this.props);
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          canSpamSettingsActions = _this$props.canSpamSettingsActions,
          hasEmailSubscriptionScope = _this$props.hasEmailSubscriptionScope;
      canSpamSettingsActions.fetchCanSpamSettingsIfNotPresent();

      if (hasEmailSubscriptionScope) {
        this.props.EmailSubscriptionsActions.fetchEmailSubscriptions();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _this$props2 = this.props,
          originalCanSpamSettings = _this$props2.originalCanSpamSettings,
          emailSubscriptionsRequestState = _this$props2.emailSubscriptionsRequestState,
          dyno = _this$props2.dyno;

      if (nextProps.users !== this.props.users || nextProps.kickbackEmails !== this.props.dyno.kickbackEmails) {
        this.props.dyno.kickbackEmails.forEach(function (email) {
          return _this2.handleKickBackEmailErrors(email);
        });
      }

      if (nextProps.emailSubscriptionsRequestState !== emailSubscriptionsRequestState && nextProps.emailSubscriptionsRequestState.isSuccessful()) {
        this.handleInitializingEmailSubscriptionId(nextProps);
      }

      if (nextProps.originalCanSpamSettings !== originalCanSpamSettings && nextProps.canSpamSettingsHasLoaded) {
        this.handleCanSpamMissing(nextProps);
      }

      if (nextProps.dyno.formFields !== dyno.formFields) {
        this.handleFormFieldValidation(nextProps);
      }
    }
  }, {
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor." + suffix;
    }
  }, {
    key: "handleFormFieldValidation",
    value: function handleFormFieldValidation(props) {
      var dyno = props.dyno,
          hasCustomFieldsScope = props.hasCustomFieldsScope;

      if (!hasCustomFieldsScope) {
        var customFields = dyno.formFields.map(function (field) {
          return field.name;
        }).filter(function (name) {
          return !(0, _underscore.contains)(DEFAULT_FIELD_TYPES, name);
        });

        if (customFields.length) {
          this.addValidationError('customFields', this.langKey('formFieldEditor.errors.customFields'), _DynoEditor.STEPS.FORM);
        } else {
          this.removeValidationError('customFields');
        }
      }
    }
  }, {
    key: "handleInitializingEmailSubscriptionId",
    value: function handleInitializingEmailSubscriptionId(props) {
      var dyno = props.dyno,
          emailSubscriptions = props.emailSubscriptions,
          hasEmailSubscriptionScope = props.hasEmailSubscriptionScope,
          emailDefaultSubscription = props.emailDefaultSubscription;

      if (!hasEmailSubscriptionScope || emailSubscriptions.length < 1) {
        return;
      }

      var emailSubscription = (0, _DynoUtils.getKickBackEmailsSubscriptionId)(dyno) || emailDefaultSubscription;
      var isEmailSubscriptionActive = emailSubscriptions.find(function (s) {
        return s.id === emailSubscription;
      });

      if (!isEmailSubscriptionActive) {
        this.props.dispatch(DynoEditorActions.addValidationErrorIfNeeded(_DynoEditor.STEPS.OPTIONS, 'missingSubscription', this.langKey('leadFlowOptionsEditor.subscription.missing')));
        this.setState({
          emailSubscriptionIdError: true
        });
      }

      this.handleUpdateEmailSubscriptionId(emailSubscription);
    }
  }, {
    key: "handleUpdateEmailSubscriptionId",
    value: function handleUpdateEmailSubscriptionId(emailSubscriptionId) {
      var removeValidationError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var dyno = this.props.dyno;
      var updateKbEmails = dyno.kickbackEmails.some(function (email) {
        return email.emailData && email.emailData.emailSubscriptionId !== emailSubscriptionId;
      });
      this.setState({
        emailSubscriptionId: emailSubscriptionId
      });

      if (updateKbEmails) {
        this.updateDyno({
          kickbackEmails: dyno.kickbackEmails.map(function (email) {
            return (0, _extends2.default)({}, email, {
              emailData: (0, _extends2.default)({}, email.emailData, {
                emailSubscriptionId: emailSubscriptionId
              })
            });
          })
        });
      }

      if (removeValidationError) {
        this.props.dispatch(DynoEditorActions.removeValidationErrorIfNeeded(_DynoEditor.STEPS.OPTIONS, 'missingSubscription'));
        this.setState({
          emailSubscriptionIdError: false
        });
      }
    }
  }, {
    key: "updateDyno",
    value: function updateDyno(update) {
      var shouldAutoSave = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.props.dispatch(DynoEditorActions.updateDyno(update, shouldAutoSave));
    }
  }, {
    key: "addValidationError",
    value: function addValidationError(field, message) {
      var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.step;
      this.props.dispatch(DynoEditorActions.addValidationErrorIfNeeded(step, field, message));
    }
  }, {
    key: "handleCanSpamMissing",
    value: function handleCanSpamMissing(nextProps) {
      var dyno = nextProps.dyno,
          originalCanSpamSettings = nextProps.originalCanSpamSettings;

      if (dyno.kickbackEmails && dyno.kickbackEmails.length && !(0, _CanSpamSettingsUtils.emailFooterIsSetUp)(originalCanSpamSettings)) {
        this.addValidationError('setUpCanSpam', this.langKey('leadFlowFollowUpEmailEditor.error.setUpFooter'), _DynoEditor.STEPS.KICKBACK);
      }
    }
  }, {
    key: "handleKickBackEmailErrors",
    value: function handleKickBackEmailErrors(email) {
      var dispatch = this.props.dispatch;

      if (email.errors && email.errors.indexOf('KICK_BACK_EMAIL_DELETED') > -1) {
        this.setState({
          showMissingKickBackEmailWarning: true
        });
        dispatch(DynoEditorActions.addValidationErrorIfNeeded(_DynoEditor.STEPS.KICKBACK, 'missingKickBackEmail', this.langKey('missingKickBackEmails')));
      }
    }
  }, {
    key: "removeValidationError",
    value: function removeValidationError(field) {
      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.step;
      var stepName = field === 'name' ? 'options' : step;
      var action = DynoEditorActions.removeValidationErrorIfNeeded(stepName, field);
      this.props.dispatch(action);
    }
  }, {
    key: "handleDismissKickBackEmailWarning",
    value: function handleDismissKickBackEmailWarning() {
      var dyno = this.props.dyno;
      this.props.dispatch(DynoEditorActions.removeValidationErrorIfNeeded(_DynoEditor.STEPS.KICKBACK, 'missingKickBackEmail'));
      this.setState({
        showMissingKickBackEmailWarning: false
      });
      var kickbackEmailsNoErrors = dyno.kickbackEmails.filter(function (email) {
        return email.errors === undefined;
      });
      this.updateDyno({
        kickbackEmails: kickbackEmailsNoErrors
      });
    }
  }, {
    key: "handleImageChange",
    value: function handleImageChange(image) {
      var dispatch = this.props.dispatch;

      if (image === null) {
        dispatch(DynoImageActions.removeUploadedDynoImage());
      } else {
        (0, _eventsTrackerUtils.trackEditorInteraction)('add-image');
        dispatch(DynoImageActions.imageUploadSuccess(image));
      }

      dispatch(DynoEditorActions.updateDyno({}, true));
    }
  }, {
    key: "fetchEspStatus",
    value: function fetchEspStatus(formGuid) {
      this.props.dispatch((0, _Subscriptions.fetchSubscriptionStatusIfNeeded)(formGuid));
    }
  }, {
    key: "handleNameBlur",
    value: function handleNameBlur(event) {
      var value = event.target.innerHTML;

      if (value.length < _DynoValidation.MIN_NAME_LENGTH) {
        this.addValidationError('name', this.langKey('leadFlowOptionsEditor.error.nameFieldRequired'));
      } else if (value.length > _DynoValidation.MAX_NAME_LENGTH) {
        this.addValidationError('name', this.langKey('leadFlowOptionsEditor.error.nameExceededMaxLength'));
      } else {
        this.removeValidationError('name');
      }
    }
  }, {
    key: "handleNameChange",
    value: function handleNameChange(_ref) {
      var value = _ref.target.value;
      this.updateDyno({
        name: value
      });

      if (value.length > _DynoValidation.MAX_NAME_LENGTH) {
        this.addValidationError('name', this.langKey('leadFlowOptionsEditor.error.nameExceededMaxLength'));
      } else {
        this.removeValidationError('name');
      }
    }
  }, {
    key: "handleRouterLeave",
    value: function handleRouterLeave(nextLocation) {
      var hasChanges = this.props.hasChanges;
      var showLeaveDialog = this.state.showLeaveDialog;
      var path = nextLocation.pathname;

      if (!path.includes("edit/" + this.props.dynoId) && hasChanges) {
        if (!path.includes("edit/" + this.props.dynoId) && hasChanges && !showLeaveDialog) {
          this.setState({
            nextLocation: path,
            showLeaveDialog: true
          });
          return false;
        }
      }

      return true;
    }
  }, {
    key: "handleLeaveConfirm",
    value: function handleLeaveConfirm() {
      this.props.dispatch(DynoEditorActions.removeAllValidationErrors());
      this.props.dispatch((0, _reactRouterRedux.push)(this.state.nextLocation));
    }
  }, {
    key: "handleLeaveCancel",
    value: function handleLeaveCancel() {
      this.setState({
        showLeaveDialog: false
      });
    } // eslint-disable-next-line consistent-return

  }, {
    key: "handleLeave",
    value: function handleLeave(event) {
      var hasChanges = this.props.hasChanges;

      var message = _I18n.default.text('leadFlowEditor.confirm.leaveWindow');

      if (hasChanges) {
        event.returnValue = message; // This message won't show in Firefox or Chrome, but it needs to be setup for the dialog to show

        return message; // for cross-browser purposses
      }
    }
  }, {
    key: "handleSave",
    value: function handleSave() {
      this.props.dispatch(DynoEditorActions.saveChangesToDyno());
    }
  }, {
    key: "handleDeleteDraft",
    value: function handleDeleteDraft(id) {
      this.props.dispatch(DynoEditorActions.deleteDynoDraft(id));
    }
  }, {
    key: "publish",
    value: function publish(state) {
      var scriptLoaderIsInstalled = this.props.settings.scriptLoaderIsInstalled;
      var props = {
        version: CURRENT_DYNO_VERSION
      };

      if (state === 'publish') {
        this.updateDyno((0, _extends2.default)({}, props, {
          enabled: true
        }));
      } else {
        this.updateDyno(props);
      }

      if (scriptLoaderIsInstalled || _hubspotPluginCommon.isWordPress) {
        this.props.dispatch(DynoEditorActions.saveChangesToDyno(this.handleCompleteModal));
      } else {
        this.props.dispatch(DynoEditorActions.saveChangesToDyno());
      }
    }
  }, {
    key: "unpublish",
    value: function unpublish() {
      this.updateDyno({
        enabled: false
      });
      this.handleSave();
    }
  }, {
    key: "handleCompleteModal",
    value: function handleCompleteModal() {
      var _this$props3 = this.props,
          redirectUrl = _this$props3.redirectUrl,
          dispatch = _this$props3.dispatch;

      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        dispatch((0, _reactRouterRedux.push)((0, _RouteGenerators.getDynoListRoute)()));
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var step = this.props.step;

      switch (step) {
        case _DynoEditor.STEPS.TYPE:
          return this.renderTypeChoiceContent();

        case _DynoEditor.STEPS.CALLOUT:
          return this.renderCalloutContent();

        case _DynoEditor.STEPS.FORM:
          return this.renderFormContent();

        case _DynoEditor.STEPS.THANKS:
          return this.renderThanksContent();

        case _DynoEditor.STEPS.KICKBACK:
          return this.renderEmailContent();

        case _DynoEditor.STEPS.OPTIONS:
          return this.renderOptionsContent();

        case _DynoEditor.STEPS.TARGETING:
          return this.renderTargetingContent();

        case _DynoEditor.STEPS.PUBLISH:
          return this.renderPublishContent();

        default:
          LOG.error("Unknown editor step " + step);
          return _react.default.createElement(_UIErrorMessage.default, {
            illustration: "errors/map",
            illustrationProps: {
              width: 220
            },
            title: _I18n.default.text(this.langKey('unknownStep'))
          }, _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
            message: this.langKey('unknownStepDescription'),
            options: {
              dashboardLink: (0, _RouteGenerators.getDynoListRoute)()
            }
          })));
      }
    }
  }, {
    key: "renderTypeChoiceContent",
    value: function renderTypeChoiceContent() {
      var _this$props4 = this.props,
          dyno = _this$props4.dyno,
          hubSettingsUpdateRequestState = _this$props4.hubSettingsUpdateRequestState,
          hasForm = _this$props4.hasForm;
      return _react.default.createElement(_DynoPanels.default, {
        step: _DynoEditor.STEPS.TYPE,
        dyno: dyno,
        hasForm: hasForm
      }, _react.default.createElement(_DynoTypePanel.default, {
        gates: this.props.gates,
        HubSettingsActions: this.props.HubSettingsActions,
        hubSettingsUpdateRequestState: hubSettingsUpdateRequestState,
        type: dyno.type,
        updateDyno: this.updateDyno
      }));
    }
  }, {
    key: "renderCalloutContent",
    value: function renderCalloutContent() {
      var _this$props5 = this.props,
          allGates = _this$props5.allGates,
          dyno = _this$props5.dyno,
          isSettingsFetching = _this$props5.isSettingsFetching,
          settings = _this$props5.settings,
          validation = _this$props5.validation,
          hasCOSAccess = _this$props5.hasCOSAccess,
          isUngatedForFormlessPopups = _this$props5.isUngatedForFormlessPopups,
          hasForm = _this$props5.hasForm;
      return _react.default.createElement(_DynoPanels.default, {
        step: _DynoEditor.STEPS.CALLOUT,
        dyno: dyno,
        hasForm: hasForm
      }, _react.default.createElement(_DynoCalloutPanel.default, {
        allGates: allGates,
        type: dyno.type,
        updateDyno: this.updateDyno,
        addValidationError: this.addValidationError,
        removeValidationError: this.removeValidationError,
        validation: validation[_DynoEditor.STEPS.CALLOUT],
        suggestedColors: settings.popupSuggestedColors || [],
        fetchingSuggestedColors: isSettingsFetching,
        heading: dyno.heading,
        description: dyno.description,
        ctaText: dyno.cta,
        color: dyno.color,
        handleImageChange: this.handleImageChange,
        imageUrl: dyno.imageResizedUrl,
        isUngatedForFormlessPopups: isUngatedForFormlessPopups,
        gates: this.props.gates,
        dismissButtonEnabled: dyno.dismissButtonEnabled,
        calloutButtonType: dyno.calloutButtonType,
        hasCOSAccess: hasCOSAccess,
        redirectButtonType: dyno.callbackButtonType
      }));
    }
  }, {
    key: "renderFormContent",
    value: function renderFormContent() {
      var _this$props6 = this.props,
          dyno = _this$props6.dyno,
          validation = _this$props6.validation,
          hasForm = _this$props6.hasForm;
      return _react.default.createElement(_DynoPanels.default, {
        step: _DynoEditor.STEPS.FORM,
        dyno: dyno,
        hasForm: hasForm
      }, _react.default.createElement(_DynoFormPanel.default, {
        type: dyno.type,
        updateDyno: this.updateDyno,
        imageUrl: dyno.imageResizedUrl,
        formDescription: dyno.formDescription,
        formCta: dyno.formCta,
        showNames: dyno.showNames,
        showPhone: dyno.showPhone,
        locale: dyno.locale,
        lifecycle: dyno.lifecycle,
        formFields: dyno.formFields,
        validation: validation[_DynoEditor.STEPS.FORM],
        addValidationError: this.addValidationError,
        removeValidationError: this.removeValidationError,
        handleImageChange: this.handleImageChange,
        isRecaptchaEnabled: dyno.kickbackEmails && dyno.kickbackEmails.length > 0 || dyno.captchaEnabled,
        isRecaptchaConfigurable: !dyno.kickbackEmails || dyno.kickbackEmails.length === 0
      }));
    }
  }, {
    key: "renderThanksContent",
    value: function renderThanksContent() {
      var _this$props7 = this.props,
          allGates = _this$props7.allGates,
          dyno = _this$props7.dyno,
          validation = _this$props7.validation,
          hasForm = _this$props7.hasForm;
      return _react.default.createElement(_DynoPanels.default, {
        step: _DynoEditor.STEPS.THANKS,
        dyno: dyno,
        hasForm: hasForm
      }, _react.default.createElement(_DynoThankYouPanel.default, {
        addValidationError: this.addValidationError,
        allGates: allGates,
        completedMessageHtml: dyno.completedMessageHtml,
        gates: this.props.gates,
        redirectButtonText: dyno.redirectButtonText,
        redirectButtonType: dyno.redirectButtonType,
        removeValidationError: this.removeValidationError,
        updateDyno: this.updateDyno,
        validation: validation[_DynoEditor.STEPS.THANKS]
      }));
    }
  }, {
    key: "renderEmailContent",
    value: function renderEmailContent() {
      var _this$props8 = this.props,
          dyno = _this$props8.dyno,
          emailSubscriptionsRequestState = _this$props8.emailSubscriptionsRequestState,
          emailSubscriptions = _this$props8.emailSubscriptions;

      if (emailSubscriptionsRequestState.isPending()) {
        return null;
      }

      return _react.default.createElement(_AsyncDynoFollowUpEmailPanel.default, {
        kickbackEmails: dyno.kickbackEmails || [],
        updateDyno: this.updateDyno,
        emailSubscriptions: emailSubscriptions
      });
    }
  }, {
    key: "renderTargetingContent",
    value: function renderTargetingContent() {
      var _this$props9 = this.props,
          dyno = _this$props9.dyno,
          validation = _this$props9.validation,
          gates = _this$props9.gates;

      if (!gates['LeadFlows:AudienceTargeting']) {
        return null;
      }

      return _react.default.createElement(_AudienceTargetingContainer.default, {
        audience: dyno.audience,
        addValidationError: this.addValidationError,
        displayOnExitIntent: dyno.displayOnExitIntent,
        displayOnScroll: dyno.displayOnScroll,
        displayOnTimedDelay: dyno.displayOnTimedDelay,
        filter: dyno.audience ? dyno.audience.filter : null,
        removeValidationError: this.removeValidationError,
        type: dyno.type,
        updateDyno: this.updateDyno,
        validation: validation[_DynoEditor.STEPS.TARGETING] || {}
      });
    }
  }, {
    key: "renderOptionsContent",
    value: function renderOptionsContent() {
      var _this$props10 = this.props,
          allGates = _this$props10.allGates,
          brandingEnabled = _this$props10.brandingEnabled,
          dyno = _this$props10.dyno,
          isCrmUser = _this$props10.isCrmUser,
          saving = _this$props10.saving,
          savingHasError = _this$props10.savingHasError,
          savingRecentError = _this$props10.savingRecentError,
          subscriptions = _this$props10.subscriptions,
          validation = _this$props10.validation,
          emailSubscriptionsAsOptions = _this$props10.emailSubscriptionsAsOptions,
          emailSubscriptionsRequestState = _this$props10.emailSubscriptionsRequestState;

      if (emailSubscriptionsRequestState.isPending()) {
        return null;
      }

      var espType;
      var espConnectionStatus;
      var espSubscriptionsCount;
      var subscriptonsForList = subscriptions.subscriptionsByFormGuid[dyno.formGuid];

      if (subscriptonsForList) {
        espType = subscriptonsForList.espType;
        espConnectionStatus = subscriptonsForList.connectionStatus;
        espSubscriptionsCount = subscriptonsForList.count;
      } else {
        espType = 'NONE';
        espConnectionStatus = 'UNKOWN';
        espSubscriptionsCount = 0;
      }

      return _react.default.createElement(_DynoOptionsPanel.default, {
        addValidationError: this.addValidationError,
        allGates: allGates,
        brandingEnabled: brandingEnabled,
        currentEmailSubscriptionId: this.state.emailSubscriptionId,
        displayOnExitIntent: dyno.displayOnExitIntent,
        displayOnMobile: dyno.displayOnMobile,
        displayOnScroll: dyno.displayOnScroll,
        displayOnTimedDelay: dyno.displayOnTimedDelay,
        dynoId: dyno.id,
        emailSubscriptionIdError: this.state.emailSubscriptionIdError,
        emailSubscriptions: emailSubscriptionsAsOptions,
        espConnectionStatus: espConnectionStatus,
        espSubscriptionsCount: espSubscriptionsCount,
        espType: espType,
        fetchEspStatus: this.fetchEspStatus,
        fetchingEspStatus: subscriptions.isFetchingStatus,
        fetchingEspStatusHasError: subscriptions.fetchingStatusHasError,
        fetchingEspStatusRecentError: subscriptions.fetchingStatusRecentError,
        formFields: dyno.formFields,
        formGuid: dyno.formGuid,
        gates: this.props.gates,
        goToWebinarWebinarKey: dyno.goToWebinarWebinarKey,
        handleCompleteModal: this.handleCompleteModal,
        handleUnpublish: this.unpublish,
        handleUpdateEmailSubscriptionId: this.handleUpdateEmailSubscriptionId,
        hasKickBackEmails: dyno.kickbackEmails && dyno.kickbackEmails.length > 0,
        ignoreDurationDays: dyno.ignoreDurationDays,
        isCrmUser: isCrmUser,
        isDynoEnabled: dyno.enabled,
        isSaving: saving,
        name: dyno.name,
        notificationEmails: dyno.notificationEmails,
        pageTypesList: dyno.pageTypesList,
        publishAt: dyno.publishAt,
        publishedAt: dyno.publishedAt,
        removeValidationError: this.removeValidationError,
        savingHasError: savingHasError,
        savingRecentError: savingRecentError,
        sendNotifications: dyno.sendNotifications,
        sfdcCampaignId: dyno.sfdcCampaignId,
        targetingOptions: dyno.targetingOptions,
        type: dyno.type,
        unpublishAt: dyno.unpublishAt,
        unpublishedAt: dyno.unpublishedAt,
        updateDyno: this.updateDyno,
        validation: validation[_DynoEditor.STEPS.OPTIONS]
      });
    }
  }, {
    key: "renderPublishContent",
    value: function renderPublishContent() {
      var _this$props11 = this.props,
          dyno = _this$props11.dyno,
          portalDomain = _this$props11.portalDomain;
      return _react.default.createElement(_DynoPublishPanel.default, {
        updateDyno: this.updateDyno,
        dyno: dyno,
        locale: dyno.locale,
        domain: portalDomain
      });
    }
  }, {
    key: "renderLeaveModal",
    value: function renderLeaveModal() {
      var showLeaveDialog = this.state.showLeaveDialog;
      return showLeaveDialog ? _react.default.createElement(_UIConfirmModal.default, {
        message: _I18n.default.text('leadFlowEditor.confirm.question'),
        description: _I18n.default.text('leadFlowEditor.confirm.leaveRoute'),
        confirmLabel: _I18n.default.text('leadFlowEditor.confirm.action.leaveRoute'),
        rejectLabel: _I18n.default.text('leadFlowEditor.confirm.action.stayOnRoute'),
        onConfirm: this.handleLeaveConfirm,
        onReject: this.handleLeaveCancel
      }) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props12 = this.props,
          dyno = _this$props12.dyno,
          handleAdvanceStep = _this$props12.handleAdvanceStep,
          handleChangeStep = _this$props12.handleChangeStep,
          hasChanges = _this$props12.hasChanges,
          readOnly = _this$props12.readOnly,
          saving = _this$props12.saving,
          savingHasError = _this$props12.savingHasError,
          savingRecentError = _this$props12.savingRecentError,
          settings = _this$props12.settings,
          step = _this$props12.step,
          validation = _this$props12.validation,
          redirectUrl = _this$props12.redirectUrl,
          gates = _this$props12.gates,
          isUngatedForMergedDashboard = _this$props12.isUngatedForMergedDashboard,
          hasForm = _this$props12.hasForm;
      var content = this.renderContent();
      var name = dyno.name === null ? '' : dyno.name;
      return _react.default.createElement(_UIEditorPage.default, {
        headerComponent: _react.default.createElement(_TitleNavigationBar.default, {
          addValidationError: this.addValidationError,
          currentStep: step,
          dyno: dyno,
          handleAdvanceStep: handleAdvanceStep,
          handleDeleteDraft: this.handleDeleteDraft,
          handlePublish: this.publish,
          hasChanges: hasChanges,
          name: name,
          readOnly: readOnly,
          removeValidationError: this.removeValidationError,
          saving: saving,
          savingHasError: savingHasError,
          savingRecentError: savingRecentError,
          scriptLoaderIsInstalled: _hubspotPluginCommon.isWordPress || settings.scriptLoaderIsInstalled || false,
          updateDyno: this.updateDyno,
          validation: validation,
          redirectUrl: redirectUrl,
          isUngatedForMergedDashboard: isUngatedForMergedDashboard
        }),
        pageLayout: 'full-width',
        tabs: _react.default.createElement(_TabsNavigationBar.default, {
          currentStep: step,
          handleChangeStep: handleChangeStep,
          validation: validation,
          gates: gates,
          isPopupFormless: !hasForm
        })
      }, _react.default.createElement(_NotificationList.default, null), this.renderLeaveModal(), content);
    }
  }]);
  return DynoEditor;
}(_react.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    allGates: state.allGates,
    emailSubscriptions: (0, _EmailSubscription2.fetchEmailSubscriptions)(state),
    emailSubscriptionsAsOptions: (0, _EmailSubscription2.fetchEmailSubscriptions)(state).map(function (subscription) {
      return {
        text: subscription.name,
        value: subscription.id
      };
    }),
    emailDefaultSubscription: (0, _EmailSubscription2.fetchEmailDefaultSubscription)(state),
    emailSubscriptionsRequestState: (0, _EmailSubscription2.getEmailSubscriptionsRequestState)(state),
    portalDomain: (0, _DynoUtils.getPortalDomain)(state),
    hasEmailSubscriptionScope: (0, _Scopes2.hasScope)(state, 'email-multi-subscriptions-access'),
    hasCustomFieldsScope: (0, _Scopes2.hasScope)(state, _Scopes.LEAD_FLOWS_CUSTOM_FIELDS_ACCESS),
    hubSettingsUpdateRequestState: HubSettingsSelectors.getUpdateRequestState(state),
    originalCanSpamSettings: (0, _CanSpamSettings2.getOriginalCanSpamSettings)(state),
    canSpamSettingsHasLoaded: (0, _CanSpamSettings2.hasCanSpamSettingsLoaded)(state),
    readOnly: (0, _Scopes2.hasReadOnlyScope)(state),
    isUngatedForMergedDashboard: state.gates['Forms:PopupFormsDashboard'] || false,
    isUngatedForFormlessPopups: state.gates['Forms:FormlessPopups'] || false,
    hasForm: (0, _Dynos.getHasForm)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    canSpamSettingsActions: (0, _redux.bindActionCreators)(CanSpamSettingsActions, dispatch),
    EmailSubscriptionsActions: (0, _redux.bindActionCreators)(EmailSubscriptionsActions, dispatch),
    HubSettingsActions: (0, _redux.bindActionCreators)(HubSettingsActions, dispatch)
  };
};

var _default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DynoEditor));

exports.default = _default;
module.exports = exports.default;